import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { QuestionInput } from '../question.types';

export interface AddEventQuestionnaireQuestionInput {
  eventId: number;
  question: Omit<QuestionInput, 'id' | 'isDeleted'>;
}

export interface AddEventQuestionnaireQuestionResult {
  addEventQuestionnaireQuestion: {
    ok: boolean;
  };
}

const AddEventQuestionnaireQuestionMutation = gql`
  mutation addEventQuestionnaireQuestion($input: AddEventQuestionnaireQuestionInput!) {
    addEventQuestionnaireQuestion(input: $input) {
      ok
    }
  }
`;

export const addEventQuestionnaireQuestion = (
  input: AddEventQuestionnaireQuestionInput
): Promise<AddEventQuestionnaireQuestionResult> => {
  return gqlClient.request<AddEventQuestionnaireQuestionResult>(
    AddEventQuestionnaireQuestionMutation,
    {
      input
    }
  );
};
